import { WISHLIST_WIDGET_NAMES } from "@/constants/widget-names";
import { WishlistsItemsTotalCountInlineWidgetDefinition } from "@apps/wishlist/definitions";
import AnalyticsEventsCollectorInterface from "@modules/analytics_events_collector/AnalyticsEventsCollector/AnalyticsEventsCollectorInterface";
import { AnalyticsEventsFactory } from "@modules/analytics_events_collector/AnalyticsEventsCollector/AnalyticsEventsFactory";
import { DynamicImportManager } from "@modules/dynamic_import/DynamicImportManager";
import WidgetInjectedSdkEvent from "@modules/sdk/common_sdk/events/WidgetInjectedSdkEvent";
import { dispatchSdkEvent } from "@modules/sdk/helpers";
import MutationObserverInjector from "@ui-utils/Injector/MutationObserverInjector";

import { LoggerInterface } from "@interfaces/LoggerInterface";

class WishlistsItemsTotalCountInlineWidgetInjector {
    constructor(
        private readonly placeholderSelector: string,
        private readonly logger: LoggerInterface,
        private readonly eventsCollector: AnalyticsEventsCollectorInterface,
        private readonly analyticsEventsFactory: AnalyticsEventsFactory,
        private readonly dynamicImportManager: DynamicImportManager,
        private readonly moi: MutationObserverInjector
    ) {}

    start() {
        this.logger.debug(
            `${WISHLIST_WIDGET_NAMES.WISHLISTS_ITEMS_TOTAL_COUNT_INLINE_WIDGET}Injector.start`,
            {
                placeholderSelector: this.placeholderSelector,
            }
        );

        const targets$ = this.moi.register({
            targetSelector: this.placeholderSelector,
        });

        targets$.subscribe((placeholder) => {
            this.logger.debug(
                `${WISHLIST_WIDGET_NAMES.WISHLISTS_ITEMS_TOTAL_COUNT_INLINE_WIDGET}Injector found placeholder`,
                placeholder
            );

            const widgetName =
                WISHLIST_WIDGET_NAMES.WISHLISTS_ITEMS_TOTAL_COUNT_INLINE_WIDGET;

            void (async () => {
                const WishlistsItemsTotalCountInlineWidget =
                    await this.dynamicImportManager.importDefault(
                        WishlistsItemsTotalCountInlineWidgetDefinition,
                        true
                    );

                const widget = new WishlistsItemsTotalCountInlineWidget(
                    {
                        target: placeholder,
                    },
                    this.logger
                );

                widget.init();

                this.eventsCollector.pushEvent(
                    this.analyticsEventsFactory.createWidgetInjected(widgetName)
                );

                dispatchSdkEvent(new WidgetInjectedSdkEvent(widgetName));
            })();
        });
    }
}

export default WishlistsItemsTotalCountInlineWidgetInjector;
